module.exports = __webpack_public_path__ + "static/media/tyrone-dancing-wolf-ellis-jr.f184d677.md";